(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"]) return;
  try {
    
  var buyButton = document.querySelector('.shopify-payment-button__button.shopify-payment-button__button--unbranded');
  buyButton.innerHTML = "Buy Now";

  } catch(e) { console.error(e); }
})();
})();
